module.exports = __webpack_public_path__ + "static/media/Ellipse.b68ab882.svg";